import { render } from "./CourseCardComponent.vue?vue&type=template&id=926222c0&scoped=true"
import script from "./CourseCardComponent.vue?vue&type=script&lang=js"
export * from "./CourseCardComponent.vue?vue&type=script&lang=js"

import "./CourseCardComponent.vue?vue&type=style&index=0&id=926222c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-926222c0"]])

export default __exports__